module.exports = __webpack_public_path__ + "static/img/userImg.3a76d1f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/testImgs/userImg.png
// module id = Swxr
// module chunks = 96